(function () {
  'use strict';

  const PENDING_WISHLIST_KEY = 'oatmeal_pending_wishlist_v1';
  const PENDING_WISHLIST_KEY_FALLBACK = 'oatmeal_pending_wishlist_v1_fallback';
  const PENDING_TTL_MS = 30 * 60 * 1000;
  const LOG_PREFIX = '[Oatmeal Wishlist Auth]';
  let pendingWishlistItem = null;

  function q(sel) { return document.querySelector(sel); }
  function backdrop() { return q('[data-oat-auth-backdrop]'); }
  function authLinks() {
    return Array.from(document.querySelectorAll('[data-oat-auth-login], [data-oat-auth-register]'));
  }

  function normalizeWishlistItem(item) {
    if (!item || typeof item !== 'object') return null;

    const normalized = {
      handle: String(item.handle || '').trim(),
      color: String(item.color || '').trim(),
      productId: String(item.productId || '').trim(),
      variantId: String(item.variantId || '').trim(),
      productUrl: String(item.productUrl || '').trim(),
    };

    if (!normalized.handle && !normalized.color && !normalized.productId && !normalized.variantId) {
      return null;
    }

    return normalized;
  }

  function log(message, payload) {
    // Quiet in production. Set window.__OAT_AUTH_DEBUG__ = true in the console to re-enable.
    if (!window.__OAT_AUTH_DEBUG__) return;
    try {
      if (payload === undefined) {
        console.info(LOG_PREFIX, message);
      } else {
        console.info(LOG_PREFIX, message, payload);
      }
    } catch (_) {}
  }

  function showSuccessToast(message) {
    const text = String(message || '').trim();
    if (!text) return;

    if (typeof window.OatmealShowToast === 'function') {
      window.OatmealShowToast(text, document.body);
      return;
    }

    let toast = document.body.querySelector('[data-oatmeal-auth-toast]');
    if (!(toast instanceof HTMLElement)) {
      toast = document.createElement('div');
      toast.setAttribute('data-oatmeal-auth-toast', '');
      toast.style.position = 'fixed';
      toast.style.left = '50%';
      toast.style.bottom = '24px';
      toast.style.transform = 'translateX(-50%) translateY(8px)';
      toast.style.zIndex = '99999';
      toast.style.pointerEvents = 'none';
      toast.style.padding = '11px 15px';
      toast.style.borderRadius = '999px';
      toast.style.background = 'rgba(118, 35, 43, 0.96)';
      toast.style.color = '#F1EDE4';
      toast.style.fontSize = '12px';
      toast.style.fontWeight = '500';
      toast.style.letterSpacing = '0.01em';
      toast.style.lineHeight = '1.25';
      toast.style.maxWidth = 'calc(100% - 32px)';
      toast.style.textAlign = 'center';
      toast.style.border = '1px solid rgba(241, 237, 228, 0.18)';
      toast.style.boxShadow = '0 14px 32px rgba(68, 16, 25, 0.22)';
      toast.style.backdropFilter = 'blur(10px)';
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 220ms ease, transform 280ms cubic-bezier(.22,.61,.36,1)';
      document.body.appendChild(toast);
    }

    toast.textContent = text;
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });

    clearTimeout(toast.__oatmealTimer);
    toast.__oatmealTimer = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(8px)';
    }, 2600);
  }

  function syncAuthLinks() {
    authLinks().forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;
      if (!link.dataset.baseHref) {
        link.dataset.baseHref = link.getAttribute('href') || '';
      }
      link.setAttribute('href', link.dataset.baseHref);
    });
  }

  function persistPendingWishlist() {
    if (!pendingWishlistItem) return;

    const payload = JSON.stringify({
      item: pendingWishlistItem,
      createdAt: Date.now(),
    });

    try {
      sessionStorage.setItem(PENDING_WISHLIST_KEY, payload);
    } catch (_) {}

    try {
      localStorage.setItem(PENDING_WISHLIST_KEY_FALLBACK, payload);
    } catch (_) {}

    log('Stored pending wishlist intent', pendingWishlistItem);
  }

  function consumePendingWishlist() {
    function readAndClear(key, storage) {
      try {
        const raw = storage.getItem(key);
        if (!raw) return null;
        storage.removeItem(key);
        return raw;
      } catch (_) {
        return null;
      }
    }

    try {
      const raw =
        readAndClear(PENDING_WISHLIST_KEY, sessionStorage) ||
        readAndClear(PENDING_WISHLIST_KEY_FALLBACK, localStorage);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      const createdAt = Number(parsed?.createdAt || 0);
      if (!createdAt || Date.now() - createdAt > PENDING_TTL_MS) return null;

      return normalizeWishlistItem(parsed?.item);
    } catch (_) {
      return null;
    }
  }

  function resumePendingWishlist() {
    if (window.OATMEAL_IS_LOGGED_IN !== true) return;

    const pending = consumePendingWishlist();
    if (!pending) return;

    log('Resuming pending wishlist intent after auth', pending);

    let tries = 0;
    (function waitForStore() {
      tries += 1;
      const store = window.OatmealWishlistStore;
      if (store) {
        store.register?.(pending);
        if (!store.has(pending)) {
          log('Wishlist store ready, adding pending item', pending);
          store.add(pending);
        } else {
          log('Wishlist store already had pending item, syncing UI only', pending);
          window.dispatchEvent(new CustomEvent('oatmeal:wishlist:changed'));
        }
        showSuccessToast('Logged in successfully!');
        return;
      }

      if (tries < 120) {
        window.setTimeout(waitForStore, 100);
      } else {
        log('Wishlist store never became ready while resuming pending intent');
      }
    })();
  }

  function open(options = {}) {
    const b = backdrop();
    if (!b) return;
    pendingWishlistItem = normalizeWishlistItem(options?.wishlistItem);
    syncAuthLinks();
    log('Opened auth prompt', { wishlistIntent: pendingWishlistItem });
    b.hidden = false;
    requestAnimationFrame(() => b.classList.add('is-open'));
  }

  function close() {
    const b = backdrop();
    if (!b) return;
    pendingWishlistItem = null;
    syncAuthLinks();
    b.classList.remove('is-open');
    setTimeout(() => { b.hidden = true; }, 220);
  }

  document.addEventListener('click', (e) => {
    const b = backdrop();
    const target = e.target instanceof Element ? e.target : null;
    const link = target ? target.closest('[data-oat-auth-login], [data-oat-auth-register]') : null;
    if (link) {
      syncAuthLinks();
      if (pendingWishlistItem) {
        persistPendingWishlist();
        log('Redirecting into auth flow from wishlist prompt', {
          href: link.getAttribute('href'),
          wishlistIntent: pendingWishlistItem,
        });
      }
      return;
    }

    if (!b || b.hidden) return;

    if (e.target.closest('[data-oat-auth-close]')) {
      close();
      return;
    }

    // click on backdrop (outside modal/sheet) closes
    if (e.target === b) {
      close();
    }
  });

  document.addEventListener('keydown', (e) => {
    const b = backdrop();
    if (!b || b.hidden) return;
    if (e.key === 'Escape') close();
  });

  syncAuthLinks();
  resumePendingWishlist();
  window.OatmealAuthPromptOpen = open;
  window.OatmealAuthPromptClose = close;
})();
